// [A53 — 2026-05-25]: whitespace-nowrap + responsive "Saved" label so the
//   header SaveIndicator doesn't wrap to multiple lines at 375px mobile
//   width. Pre-fix the text "✓ Saved just now" wrapped to three lines
//   ("Saved" / "just" / "now") because the parent flex container in
//   App.jsx:9483 squeezes children as more siblings appear.
import React, { useState, useEffect } from 'react';

function timeAgo(ts) {
  if (!ts) return '';
  const mins = Math.floor((Date.now() - ts) / 60000);
  if (mins < 1) return 'just now';
  if (mins === 1) return '1m ago';
  return `${mins}m ago`;
}

export default function SaveIndicator({ lastSavedAt, isSaving, hasUnsaved }) {
  const [, forceUpdate] = useState(0);

  useEffect(() => {
    if (!lastSavedAt) return;
    const interval = setInterval(() => forceUpdate(n => n + 1), 30000);
    return () => clearInterval(interval);
  }, [lastSavedAt]);

  if (isSaving) {
    return (
      <span className="text-xs text-gray-400 animate-pulse whitespace-nowrap" aria-live="polite">
        Saving...
      </span>
    );
  }
  if (hasUnsaved) {
    return (
      <span
        className="text-xs text-amber-400 whitespace-nowrap"
        aria-live="polite"
        title="Changes not yet saved"
      >
        ● <span className="hidden sm:inline">Unsaved</span>
      </span>
    );
  }
  if (lastSavedAt) {
    return (
      <span className="text-xs text-gray-500 whitespace-nowrap" aria-live="polite">
        ✓ <span className="hidden sm:inline">Saved </span>{timeAgo(lastSavedAt)}
      </span>
    );
  }
  return null;
}
